import styled from "styled-components";

const StatePopupIconBox = styled.div`
    margin-bottom: 20px;
    
    height: 52px;
    width: 52px;
    
    mask-image: url(${({theme}) => theme.images.statePopup.locationIcon.toString()});
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    
    background: ${props => props.theme.colors.brandSecondary} no-repeat center;
    background-size: contain;
`;

export default StatePopupIconBox;